"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.FormText = react_1.forwardRef((_a, ref) => {
    var { variant } = _a, rest = __rest(_a, ["variant"]);
    return (jsx_runtime_1.jsx(Box_1.Box, Object.assign({ as: "span", ref: ref, display: "block", fontWeight: 300, fontSize: "0.75rem", textAlign: "left", color: variant === 'error' ? 'danger' : undefined, my: 1 }, rest), void 0));
});
//# sourceMappingURL=index.js.map